import { useCallback } from 'react';
import { useAutomationRuleActions } from '../use-actions';
import { ActionItemType, AddCommentToWorkItemActionType } from '../types';

interface Props {
  actionId: string;
}

export function useAddCommentForRelationships(props: Props) {
	const {setActions, actions} = useAutomationRuleActions();

	const onOptionsSelect = useCallback((value: string) => {
		setActions(oldActions => {
			const currentAction = oldActions.find(action => action.id === props.actionId) as ActionItemType;
			const others = oldActions.filter(action => action.id !== props.actionId);

			return [
				...others,
				{
					...currentAction,
					addCommentToWorkItem: {
						...currentAction.addCommentToWorkItem as AddCommentToWorkItemActionType,
						relationship: value,
					},
				},
			];
		});
	}, [props.actionId, actions]);

	return {
		onOptionsSelect,
	};
}
